var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10C5 9.44771 5.44772 9 6 9H7C7.55228 9 8 8.55228 8 8V4.78078C8 4.32191 8.3123 3.92193 8.75746 3.81063L12 3V5L10.7575 5.31063C10.3123 5.42193 10 5.82191 10 6.28078V8C10 8.55228 10.4477 9 11 9H13C13.5523 9 14 8.55228 14 8V6.28078C14 5.82191 13.6877 5.42193 13.2425 5.31063L12 5V3L15.2425 3.81063C15.6877 3.92193 16 4.32191 16 4.78078V8C16 8.55228 16.4477 9 17 9H18C18.5523 9 19 9.44772 19 10V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V10Z",
    fill: "#9D9D9D"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lock.041d7ef2.svg";
export { ForwardRef as ReactComponent };